// Core screen identifiers (subset of AddToConstants.SCREENS)
export const SCREENS = {
  DEFAULT: 'DEFAULT',
  SIGN_IN: 'SIGN_IN',
  LOADING: 'LOADING',
  ADD_TO_SELECTION: 'ADD_TO_SELECTION',
  // List
  LIST_CREATE_LIST: 'LIST_CREATE_LIST',
  LIST_SELECT_LIST: 'LIST_SELECT_LIST',
  LIST_SELECT_GROUP: 'LIST_SELECT_GROUP',
  LIST_SUCCESS: 'LIST_SUCCESS',
  // Project
  PROJECT_SELECT_PROJECT: 'PROJECT_SELECT_PROJECT',
  PROJECT_CREATE_PROJECT: 'PROJECT_CREATE_PROJECT',
  PROJECT_ZERO_STATE: 'PROJECT_ZERO_STATE',
  CREATE_PROJECT_PREVIEW: 'CREATE_PROJECT_PREVIEW',
  PROJECT_SUCCESS: 'PROJECT_SUCCESS',
  // Copy List
  COPY_LIST_SUMMARY: 'COPY_LIST_SUMMARY',
  COPY_LIST_PRODUCTS: 'COPY_LIST_PRODUCTS',
  MY_STORE: 'MY_STORE',
  DELIVERY_ZIP: 'DELIVERY_ZIP',
  // Selection
  CHOOSING_THE_RIGHT_TOOL: 'CHOOSING_THE_RIGHT_TOOL',
  // Quote
  LOADING_STATUS: 'LOADING_STATUS',
  PRODUCT_EXCEPTIONS: 'PRODUCT_EXCEPTIONS',
};

export const ADD_TO_TYPE = {
  LIST: 'List',
  QUOTE: 'Quote',
  PROJECT: 'Project',
};

// Re-export only the errors core components need
export { ERROR, TRACK, SELECTION_TYPE, LAST_USED_PROJECT_KEY } from '../AddToConstants';
